import React from 'react';
import useLoadingStore from '@/store/loading';

const LoadingOverlay: React.FC = () => {
  const { loading } = useLoadingStore();

  return (
    <div
      role="presentation"
      className={`fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 flex items-center justify-center z-50 ${
        loading ? 'block' : 'hidden'
      }`}
    >
      {/* Spinner */}
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid border-opacity-75"></div>
    </div>
  );
};

export default LoadingOverlay;
